import styled from 'styled-components';
import { theme } from '../../style/theme';
import { mixins } from '../../style/mixins';
import { device } from '../../style/device';

const { colors } = theme;

export const StyledContainer = styled.footer`
  ${mixins.flexCenter};
  flex-direction: column;
  padding: 15px;
  text-align: center;
  height: auto;
  min-height: 70px;
`;

export const StyledSocial = styled.div`
  color: ${colors.lightSlate};
  width: 100%;
  max-width: 270px;
  margin: 0 auto 10px;
  display: none;
  ${device.tablet`display: block;`};
`;

export const StyledSocialList = styled.ul`
  ${mixins.flexBetween};
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const StyledSocialLink = styled.a`
  padding: 10px;
  svg {
    width: 20px;
    height: 20px;
    fill: ${colors.slate}
    
  }
  &:hover{
      svg {
          fill: ${colors.primary}
      }
  }
`;